import getCurrencyOfferByPeriod from "../../Plans/utils/getCurrencyOfferByPeriod";
import { getPaymentMethodPricing } from "../../Plans/utils/useOnPaymentButtonClick";
import useIsDesktop from "../../../hooks/useIsDesktop";
import classNames from "classnames";
import FormatCurrency from "./FormatCurrency";
import Period from "../../Plans/components/Period";
import Link from "../../../../common/SquaberLink";
import { UrlProvider } from "../../../../../../api/UrlProvider";
import React from "react";

export const PlanTableBoxContent = ({
  plan,
  currentPeriod,
  translate,
  locale
}) => {
  const currencyOffer = getCurrencyOfferByPeriod({
    currency_offers: plan.currency_offers,
    period: currentPeriod
  });
  const paymentMethodPricing = getPaymentMethodPricing({
    currentCurrencyOfferByPeriod: currencyOffer
  });

  const isDesktop = useIsDesktop();

  return (
    <>
      <h3
        className={classNames({
          "text-2xl.1": isDesktop,
          "text-2xl": !isDesktop
        })}
      >
        {plan.name}
      </h3>
      <p className={"text-xs mt-3 mb-5 text-black-8"}>{plan.description}</p>
      <div className={"flex flex-col mt-auto"}>
        {paymentMethodPricing?.order_monthly_amount !==
        paymentMethodPricing?.monthly_amount ? (
          <strong
            className={
              "ml-auto text-xl font-bold text-red-1 line-through ml-auto"
            }
          >
            <FormatCurrency
              value={paymentMethodPricing.monthly_amount}
              locale={locale}
            />
          </strong>
        ) : null}
        <div className={"flex gap-2 align-baseline"}>
          <strong className={"text-2xl.1 font-bold"}>
            <FormatCurrency
              value={paymentMethodPricing?.order_monthly_amount ?? 0}
              locale={locale}
            />
          </strong>
          <div className={"flex flex-col w-full"}>
            <span className={"text-xs text-black-5 whitespace-nowrap"}>
              <Period periods={1} />
            </span>
          </div>
        </div>
      </div>
      {currencyOffer?.omnibus_price ? (
        <div className={"ml-auto mt-1.5 mb-3"}>
          <span className={"text-xs.1 text-black opacity-50 flex font-normal"}>
            {translate("plans_box_omnibus-price", {
              value: FormatCurrency({
                value: currencyOffer.omnibus_price,
                locale
              })
            })}
          </span>
        </div>
      ) : null}
      <Link
        to={UrlProvider.getUrl("fe.plans.availableInPlanWithPeriod", {
          locale,
          id: plan.id,
          period: currentPeriod
        })}
        className={"button-1 block w-full mt-3"}
      >
        {translate("lp_plan-table-box-content_choose")}
      </Link>
    </>
  );
};
